import { useEffect, useRef } from 'react';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import { useApplyCouponCode } from 'src/state/actions/cart';

/**
 * Reads a `?promo=` query param from the URL and auto-applies it as a coupon code.
 * Only fires once, and only when the dispensary setting is enabled and the cart is ready
 * (not calculating and has a valid subtotal).
 */
export function useAutoApplyPromoCode(
  dispensaryId: string | undefined,
  isEnabled: boolean,
  isCartReady: boolean,
  rewardsProgramDisplayName: string
): void {
  const applyCouponCode = useApplyCouponCode();
  const hasApplied = useRef(false);
  const [query] = useQueryParams({
    promo: withDefault(StringParam, null),
  });

  useEffect(() => {
    if (!hasApplied.current && query.promo && isEnabled && dispensaryId && isCartReady) {
      hasApplied.current = true;
      void applyCouponCode(query.promo, dispensaryId, true, rewardsProgramDisplayName);
    }
  }, [query.promo, isEnabled, dispensaryId, isCartReady, rewardsProgramDisplayName, applyCouponCode]);
}
